import axios from "./Api";
export const Autocomplete = async (
  name: string,
  type: string,
  routName: string
) => {
  switch (true) {
    case type === "productName" && routName === "sku": {
      const url = `/api/app/stock-keeping-unit/search-by-name?term=${name}`;
      const data = await axios.post(url);
      return data;
    }
    case type === "ManufacturerId": {
      const url = `/api/app/stock-keeping-unit/manufacturers`;
      const data = await axios.get(url);
      return data;
    }
    case (type === "productName" && routName === "product") ||
      routName === "invetory-history": {
      const url = `/api/app/product/search-by-name?name=${name}`;
      const data = await axios.post(url);
      return data;
    }

    default:
      return [];
  }
};

export const ChangeWarehouseStatus = async (type: string, params: any) => {
  switch (true) {
    case type === "towarehouse": {
      const url = `/api/app/product/to-warehouse?type=${params.type}`;
      const data = await axios.post(url, params);
      return data;
    }

    case type === "transfer": {
      const url = `/api/app/transfer-request`;
      const data = await axios.post(url, params);
      return data;
    }

    case type === "exit": {
      const { skuId, type, quantity, reserveId, warehouseId }: any = params;
      const url = `/api/app/product/from-warehouse?skuId=${skuId}&Quantity=${quantity}&ReserveId=${reserveId}&WarehouseId=${warehouseId}&type=${type}`;
      const data = await axios.delete(url);
      return data;
    }
  }
};

export const GetManufactureList = async () => {
  const url = `/api/app/stock-keeping-unit/manufacturers`;
  const data = await axios.get(url);
  return data;
};
export const GetMyProfile = async () => {
  const url = `/api/account/my-profile`;
  const data = await axios.get(url);
  return data;
};
